import styles from "./checkBox.module.css";

const CheckBox = ({
  id,
  label,
  checked,
  onChange,
  disabled = false,
  className = "",
  labelClass = "",
}) => {
  return (
    <label htmlFor={id} className={`${styles.checkboxWrapper} ${className}`}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={styles.input}
      />
      <span className={styles.customBox}></span>
      {label && (
        <span className={`${styles.label} ${labelClass}`}>{label}</span>
      )}
    </label>
  );
};

export default CheckBox;
